import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';
import { Paper, Typography, Skeleton, Box } from '@mui/material';

const BAR_COLOR = '#1976d2';

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  const { hourRange, value } = payload[0].payload;

  return (
    <Box bgcolor="#fff" p={1} boxShadow={2} borderRadius={1}>
      <Typography variant="subtitle2">🕒 {hourRange} hs</Typography>
      <Typography variant="body2" fontWeight="bold">
        🧾 {value} tickets
      </Typography>
    </Box>
  );
};

const SalesByHourChart = ({ data = [], loading }) => (
  <Paper elevation={2} sx={{ p: 2, height: 360 }}>
    <Typography variant="subtitle1" gutterBottom>
      Ventas por franja horaria
    </Typography>

    <Box sx={{ width: '100%', height: 300 }}>
      {loading ? (
        <Skeleton variant="rectangular" width="100%" height={300} />
      ) : data.length > 0 ? (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 20, right: 20, bottom: 0, left: 0 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="hourRange" interval={0} tick={{ fontSize: 12 }} />
            <YAxis />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="value" fill={BAR_COLOR} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="body2" color="textSecondary">
            No hay datos disponibles.
          </Typography>
        </Box>
      )}
    </Box>
  </Paper>
);

export default SalesByHourChart;
